/*eslint-disable block-scoped-var, no-redeclare, no-control-regex, no-prototype-builtins*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.ContinentListProto = (function() {

    /**
     * Properties of a ContinentListProto.
     * @typedef ContinentListProto$Properties
     * @type {Object}
     * @property {Array.<ContinentProto$Properties>} [continents] ContinentListProto continents.
     */

    /**
     * Constructs a new ContinentListProto.
     * @exports ContinentListProto
     * @constructor
     * @param {ContinentListProto$Properties=} [properties] Properties to set
     */
    function ContinentListProto(properties) {
        this.continents = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ContinentListProto continents.
     * @type {Array.<ContinentProto$Properties>}
     */
    ContinentListProto.prototype.continents = $util.emptyArray;

    /**
     * Creates a new ContinentListProto instance using the specified properties.
     * @param {ContinentListProto$Properties=} [properties] Properties to set
     * @returns {ContinentListProto} ContinentListProto instance
     */
    ContinentListProto.create = function create(properties) {
        return new ContinentListProto(properties);
    };

    /**
     * Decodes a ContinentListProto message from the specified reader or buffer.
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ContinentListProto} ContinentListProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContinentListProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ContinentListProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.continents && message.continents.length))
                    message.continents = [];
                message.continents.push($root.ContinentProto.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    return ContinentListProto;
})();

$root.ContinentProto = (function() {

    /**
     * Properties of a ContinentProto.
     * @typedef ContinentProto$Properties
     * @type {Object}
     * @property {string} [isoCode] ContinentProto isoCode.
     * @property {Array.<SubContinentProto$Properties>} [subContinents] ContinentProto subContinents.
     */

    /**
     * Constructs a new ContinentProto.
     * @exports ContinentProto
     * @constructor
     * @param {ContinentProto$Properties=} [properties] Properties to set
     */
    function ContinentProto(properties) {
        this.subContinents = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ContinentProto isoCode.
     * @type {string}
     */
    ContinentProto.prototype.isoCode = "";

    /**
     * ContinentProto subContinents.
     * @type {Array.<SubContinentProto$Properties>}
     */
    ContinentProto.prototype.subContinents = $util.emptyArray;

    /**
     * Creates a new ContinentProto instance using the specified properties.
     * @param {ContinentProto$Properties=} [properties] Properties to set
     * @returns {ContinentProto} ContinentProto instance
     */
    ContinentProto.create = function create(properties) {
        return new ContinentProto(properties);
    };

    /**
     * Decodes a ContinentProto message from the specified reader or buffer.
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ContinentProto} ContinentProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContinentProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ContinentProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.isoCode = reader.string();
                break;
            case 2:
                if (!(message.subContinents && message.subContinents.length))
                    message.subContinents = [];
                message.subContinents.push($root.SubContinentProto.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    return ContinentProto;
})();

$root.SubContinentProto = (function() {

    /**
     * Properties of a SubContinentProto.
     * @typedef SubContinentProto$Properties
     * @type {Object}
     * @property {string} [isoCode] SubContinentProto isoCode.
     * @property {Array.<CountryProto$Properties>} [countries] SubContinentProto countries.
     */

    /**
     * Constructs a new SubContinentProto.
     * @exports SubContinentProto
     * @constructor
     * @param {SubContinentProto$Properties=} [properties] Properties to set
     */
    function SubContinentProto(properties) {
        this.countries = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SubContinentProto isoCode.
     * @type {string}
     */
    SubContinentProto.prototype.isoCode = "";

    /**
     * SubContinentProto countries.
     * @type {Array.<CountryProto$Properties>}
     */
    SubContinentProto.prototype.countries = $util.emptyArray;

    /**
     * Creates a new SubContinentProto instance using the specified properties.
     * @param {SubContinentProto$Properties=} [properties] Properties to set
     * @returns {SubContinentProto} SubContinentProto instance
     */
    SubContinentProto.create = function create(properties) {
        return new SubContinentProto(properties);
    };

    /**
     * Decodes a SubContinentProto message from the specified reader or buffer.
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SubContinentProto} SubContinentProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubContinentProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SubContinentProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.isoCode = reader.string();
                break;
            case 2:
                if (!(message.countries && message.countries.length))
                    message.countries = [];
                message.countries.push($root.CountryProto.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    return SubContinentProto;
})();

$root.CountryProto = (function() {

    /**
     * Properties of a CountryProto.
     * @typedef CountryProto$Properties
     * @type {Object}
     * @property {string} [isoCode] CountryProto isoCode.
     * @property {string} [name] CountryProto name.
     * @property {string} [domainExtension] CountryProto domainExtension.
     * @property {GeoPointProto$Properties} [capitalPosition] CountryProto capitalPosition.
     * @property {GeoPointProto$Properties} [focusPosition] CountryProto focusPosition.
     * @property {number} [cameraAltitude] CountryProto cameraAltitude.
     * @property {Array.<PolygonProto$Properties>} [ldPolygons] CountryProto ldPolygons.
     * @property {Array.<PolygonProto$Properties>} [hdPolygons] CountryProto hdPolygons.
     * @property {MeshDataProto$Properties} [meshData] CountryProto meshData.
     */

    /**
     * Constructs a new CountryProto.
     * @exports CountryProto
     * @constructor
     * @param {CountryProto$Properties=} [properties] Properties to set
     */
    function CountryProto(properties) {
        this.ldPolygons = [];
        this.hdPolygons = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CountryProto isoCode.
     * @type {string}
     */
    CountryProto.prototype.isoCode = "";

    /**
     * CountryProto name.
     * @type {string}
     */
    CountryProto.prototype.name = "";

    /**
     * CountryProto domainExtension.
     * @type {string}
     */
    CountryProto.prototype.domainExtension = "";

    /**
     * CountryProto capitalPosition.
     * @type {(GeoPointProto$Properties|null)}
     */
    CountryProto.prototype.capitalPosition = null;

    /**
     * CountryProto focusPosition.
     * @type {(GeoPointProto$Properties|null)}
     */
    CountryProto.prototype.focusPosition = null;

    /**
     * CountryProto cameraAltitude.
     * @type {number}
     */
    CountryProto.prototype.cameraAltitude = 0;

    /**
     * CountryProto ldPolygons.
     * @type {Array.<PolygonProto$Properties>}
     */
    CountryProto.prototype.ldPolygons = $util.emptyArray;

    /**
     * CountryProto hdPolygons.
     * @type {Array.<PolygonProto$Properties>}
     */
    CountryProto.prototype.hdPolygons = $util.emptyArray;

    /**
     * CountryProto meshData.
     * @type {(MeshDataProto$Properties|null)}
     */
    CountryProto.prototype.meshData = null;

    /**
     * Creates a new CountryProto instance using the specified properties.
     * @param {CountryProto$Properties=} [properties] Properties to set
     * @returns {CountryProto} CountryProto instance
     */
    CountryProto.create = function create(properties) {
        return new CountryProto(properties);
    };

    /**
     * Decodes a CountryProto message from the specified reader or buffer.
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CountryProto} CountryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CountryProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CountryProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.isoCode = reader.string();
                break;
            case 2:
                message.name = reader.string();
                break;
            case 3:
                message.domainExtension = reader.string();
                break;
            case 4:
                message.capitalPosition = $root.GeoPointProto.decode(reader, reader.uint32());
                break;
            case 5:
                message.focusPosition = $root.GeoPointProto.decode(reader, reader.uint32());
                break;
            case 6:
                message.cameraAltitude = reader.float();
                break;
            case 7:
                if (!(message.ldPolygons && message.ldPolygons.length))
                    message.ldPolygons = [];
                message.ldPolygons.push($root.PolygonProto.decode(reader, reader.uint32()));
                break;
            case 8:
                if (!(message.hdPolygons && message.hdPolygons.length))
                    message.hdPolygons = [];
                message.hdPolygons.push($root.PolygonProto.decode(reader, reader.uint32()));
                break;
            case 9:
                message.meshData = $root.MeshDataProto.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    return CountryProto;
})();

$root.GeoPointProto = (function() {

    /**
     * Properties of a GeoPointProto.
     * @typedef GeoPointProto$Properties
     * @type {Object}
     * @property {number} [latitude] GeoPointProto latitude.
     * @property {number} [longitude] GeoPointProto longitude.
     */

    /**
     * Constructs a new GeoPointProto.
     * @exports GeoPointProto
     * @constructor
     * @param {GeoPointProto$Properties=} [properties] Properties to set
     */
    function GeoPointProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GeoPointProto latitude.
     * @type {number}
     */
    GeoPointProto.prototype.latitude = 0;

    /**
     * GeoPointProto longitude.
     * @type {number}
     */
    GeoPointProto.prototype.longitude = 0;

    /**
     * Creates a new GeoPointProto instance using the specified properties.
     * @param {GeoPointProto$Properties=} [properties] Properties to set
     * @returns {GeoPointProto} GeoPointProto instance
     */
    GeoPointProto.create = function create(properties) {
        return new GeoPointProto(properties);
    };

    /**
     * Decodes a GeoPointProto message from the specified reader or buffer.
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GeoPointProto} GeoPointProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GeoPointProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GeoPointProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.latitude = reader.float();
                break;
            case 2:
                message.longitude = reader.float();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    return GeoPointProto;
})();

$root.PolygonProto = (function() {

    /**
     * Properties of a PolygonProto.
     * @typedef PolygonProto$Properties
     * @type {Object}
     * @property {Array.<GeoPointProto$Properties>} [points] PolygonProto points.
     */

    /**
     * Constructs a new PolygonProto.
     * @exports PolygonProto
     * @constructor
     * @param {PolygonProto$Properties=} [properties] Properties to set
     */
    function PolygonProto(properties) {
        this.points = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PolygonProto points.
     * @type {Array.<GeoPointProto$Properties>}
     */
    PolygonProto.prototype.points = $util.emptyArray;

    /**
     * Creates a new PolygonProto instance using the specified properties.
     * @param {PolygonProto$Properties=} [properties] Properties to set
     * @returns {PolygonProto} PolygonProto instance
     */
    PolygonProto.create = function create(properties) {
        return new PolygonProto(properties);
    };

    /**
     * Decodes a PolygonProto message from the specified reader or buffer.
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PolygonProto} PolygonProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PolygonProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolygonProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.points && message.points.length))
                    message.points = [];
                message.points.push($root.GeoPointProto.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    return PolygonProto;
})();

$root.MeshDataProto = (function() {

    /**
     * Properties of a MeshDataProto.
     * @typedef MeshDataProto$Properties
     * @type {Object}
     * @property {Array.<GeoPointProto$Properties>} [vertices] MeshDataProto vertices.
     * @property {Array.<number>} [indices] MeshDataProto indices.
     */

    /**
     * Constructs a new MeshDataProto.
     * @exports MeshDataProto
     * @constructor
     * @param {MeshDataProto$Properties=} [properties] Properties to set
     */
    function MeshDataProto(properties) {
        this.vertices = [];
        this.indices = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MeshDataProto vertices.
     * @type {Array.<GeoPointProto$Properties>}
     */
    MeshDataProto.prototype.vertices = $util.emptyArray;

    /**
     * MeshDataProto indices.
     * @type {Array.<number>}
     */
    MeshDataProto.prototype.indices = $util.emptyArray;

    /**
     * Creates a new MeshDataProto instance using the specified properties.
     * @param {MeshDataProto$Properties=} [properties] Properties to set
     * @returns {MeshDataProto} MeshDataProto instance
     */
    MeshDataProto.create = function create(properties) {
        return new MeshDataProto(properties);
    };

    /**
     * Decodes a MeshDataProto message from the specified reader or buffer.
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MeshDataProto} MeshDataProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MeshDataProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MeshDataProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.vertices && message.vertices.length))
                    message.vertices = [];
                message.vertices.push($root.GeoPointProto.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.indices && message.indices.length))
                    message.indices = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.indices.push(reader.int32());
                } else
                    message.indices.push(reader.int32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    return MeshDataProto;
})();

module.exports = $root;



// WEBPACK FOOTER //
// ./src/earth/dataAccess/countryProto.js